export enum EmployerHiringUpdateFlowType {
  ON_JOB_LISTING_STATUS_UPDATE = 'ON_JOB_LISTING_STATUS_UPDATE',
  ON_REPORTED_BY_TEACHER = 'ON_REPORTED_BY_TEACHER',
  ON_LONG_GAP_BETWEEN_SURVEYS = 'ON_LONG_GAP_BETWEEN_SURVEYS',
}

export enum HiringUpdateFlowSteps {
  TEACHER_HIRE_CONFIRMATION = 'TEACHER_HIRE_CONFIRMATION',
  HIRED_SOMEONE_LATELY = 'HIRED_SOMEONE_LATELY',
  HIRED_SOMEONE = 'HIRED_SOMEONE',
  WHICH_PLATFORM = 'WHICH_PLATFORM',
  HIRED_WHO = 'HIRED_WHO',
  HIRED_WHO_ELSE = 'HIRED_WHO_ELSE',
  HIRED_FOR_ROLES = 'HIRED_FOR_ROLES',
  HIRED_ADDITIONAL_FOR_ROLES = 'HIRED_ADDITIONAL_FOR_ROLES',
  WHICH_THIRD_PARTY_PLATFORMS = 'WHICH_THIRD_PARTY_PLATFORMS',
  REASON_NOT_EARLYDAY = 'REASON_NOT_EARLYDAY',
  FEEDBACK_ADD_MORE = 'FEEDBACK_ADD_MORE',
  FEEDBACK_HIRE_DENIED = 'FEEDBACK_HIRE_DENIED',
  FEEDBACK = 'FEEDBACK',
}

export const FlowTypeToInitialStepMap = new Map<
  EmployerHiringUpdateFlowType,
  HiringUpdateFlowSteps
>([
  [EmployerHiringUpdateFlowType.ON_JOB_LISTING_STATUS_UPDATE, HiringUpdateFlowSteps.HIRED_SOMEONE],
  [
    EmployerHiringUpdateFlowType.ON_REPORTED_BY_TEACHER,
    HiringUpdateFlowSteps.TEACHER_HIRE_CONFIRMATION,
  ],
  [
    EmployerHiringUpdateFlowType.ON_LONG_GAP_BETWEEN_SURVEYS,
    HiringUpdateFlowSteps.HIRED_SOMEONE_LATELY,
  ],
]);
